import { useEffect } from "react";

export default function useAsyncEffect(
  effect: () => void,
  deps?: any[] | undefined,
) {
  useEffect(() => {
    (async function () {
      await effect();
    })();
  }, deps);
}
